/**
 * LIMITE DE 60 CARACTERES NA RAZÃO SOCIAL (decisão do Matheus, 15/08/2026).
 *
 * O Omie recusa razão social acima de 60 (medido na recusa real do
 * IncluirCliente no piloto da fase 7). A decisão: o v2 passa a LIMITAR o
 * campo a 60 — ciente do trade-off de que ele pode não guardar o nome
 * jurídico completo (aviso no CLAUDE.md).
 *
 * O que torna a regra segura: NUNCA truncar sozinho. O campo exibe o nome
 * inteiro (o lookup de CNPJ continua trazendo completo), mostra o contador,
 * BLOQUEIA o salvar e OFERECE a abreviação no padrão da casa — a pessoa
 * aceita ou reescreve, preservando o que identifica o cliente (a
 * implantação de 2025 truncou cegamente e a base do Omie ficou com
 * "...BOULEVARD MORUMB" e "...ATMOSPH", cortados no meio da palavra).
 */

export const LIMITE_RAZAO_SOCIAL_OMIE = 60;

/**
 * Dicionário do padrão que a própria base do Omie já usa
 * ("ASSOC DOS PROPR DO LOTEAMENTO RESID VILLA BELLA SIENA").
 * Enxuto de propósito: só palavras com abreviação consagrada na base.
 */
const ABREVIACOES: Array<[RegExp, string]> = [
  [/\bASSOCIACAO\b/gi, 'ASSOC'],
  [/\bASSOCIAÇÃO\b/gi, 'ASSOC'],
  [/\bPROPRIETARIOS\b/gi, 'PROPR'],
  [/\bPROPRIETÁRIOS\b/gi, 'PROPR'],
  [/\bPROPRIETARIO\b/gi, 'PROPR'],
  [/\bPROPRIETÁRIO\b/gi, 'PROPR'],
  [/\bRESIDENCIAL\b/gi, 'RESID'],
  [/\bCONDOMINIO\b/gi, 'COND'],
  [/\bCONDOMÍNIO\b/gi, 'COND'],
  [/\bEMPREENDIMENTOS\b/gi, 'EMPREEND'],
  [/\bADMINISTRADORA\b/gi, 'ADM'],
];

/**
 * Sugere a abreviação no padrão da casa. Devolve `null` quando nem
 * abreviando cabe em 60 — aí não há sugestão honesta e a pessoa reescreve
 * (sugerir truncamento seria truncar com outro nome).
 */
export function sugerirRazaoAbreviada(nome: string): string | null {
  let s = nome.trim().replace(/\s+/g, ' ');
  if (s.length <= LIMITE_RAZAO_SOCIAL_OMIE) return null; // já cabe — sem sugestão
  for (const [re, abrev] of ABREVIACOES) {
    s = s.replace(re, abrev);
    if (s.length <= LIMITE_RAZAO_SOCIAL_OMIE) return s;
  }
  return s.length <= LIMITE_RAZAO_SOCIAL_OMIE ? s : null;
}

/** A mensagem única das três telas — português humano, com o porquê. */
export function mensagemRazaoLonga(tamanho: number): string {
  return (
    `A razão social tem ${tamanho} caracteres e o limite é ${LIMITE_RAZAO_SOCIAL_OMIE} — ` +
    `o Omie, onde o cadastro é faturado, não aceita mais que isso. ` +
    `Encurte mantendo o que identifica o cliente (ex.: "ASSOCIACAO DOS PROPRIETARIOS" vira "ASSOC DOS PROPR").`
  );
}
